import React from "react";
import Header from "components/layout/header";
import NoDocs from "icons/document/NoDocs";
import {
  PAGE_TITLE,
  NO_DOCUMENTS_TITLE,
  NO_DOCUMENTS_DESCRIPTION,
  EMPTY_STATE_ICON_SIZE,
} from "constants/documents";
import { useTestAttrsFactory } from "utils/testid";

interface EmptyDocumentsStateProps {
  showWarn?: boolean;
}

const EmptyDocumentsState: React.FC<EmptyDocumentsStateProps> = ({
  showWarn = false,
}) => {
  const testAttrs = useTestAttrsFactory();
  return (
    <div
      className="w-full lg:h-[var(--shell-vh)] h-[75%]"
      {...testAttrs("empty-page", "No documents")}
    >
      <Header
        headerContent={
          <div
            className="w-full lg:text-[32px] sm:text-3xl text-2xl leading-[44px] text-txtPrimary font-medium -tracking-[0.72px] lg:p-0 p-5"
            {...testAttrs("title")}
          >
            {PAGE_TITLE}
          </div>
        }
      />
      <div
        className="h-full overflow-y-clip grid place-items-center"
        {...testAttrs("empty-state", "No documents available")}
      >
        <div className="text-center h-fit">
          <div
            className={`${
              showWarn ? "h-[calc(var(--shell-vh)-100px)]" : ""
            } w-full flex items-center flex-col justify-center gap-10`}
          >
            <span className="hidden lg:block">
              <NoDocs aria-hidden="true" />
            </span>
            <span className="lg:hidden block">
              <NoDocs
                width={EMPTY_STATE_ICON_SIZE.MOBILE}
                height={EMPTY_STATE_ICON_SIZE.MOBILE}
                aria-hidden="true"
              />
            </span>
            <div className="grid place-items-center">
              <p className="lg:text-2xl text-xl text-txtPrimary font-semibold mb-4">
                {NO_DOCUMENTS_TITLE}
              </p>
              <p className="lg:text-lg text-txtParagraph whitespace-normal break-words w-[90%]">
                {NO_DOCUMENTS_DESCRIPTION}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmptyDocumentsState;
